<div class="content-wrapper container-xxl p-0" *ngIf="formGroup">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <form class="form form-vertical" [formGroup]="formGroup" (ngSubmit)="isEdit ? update() : create()">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!--marca/modello-->
              <div class="form-group col-xl-3 col-md-6 col-12">
                <label for="name">{{ "BRAND_MODEL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="name" class="form-control {{ fieldHasErrors('name') ? 'is-invalid' : '' }}" formControlName="name" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.name.errors?.required">{{ "ERRORS.INSERT_NAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.name?.errors?.minlength">{{ "MIN" | translate }} 3 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.name?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <!--categoria-->
              <div class="form-group col-xl-3 col-md-6 col-12">
                <label for="category">{{ "CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  formControlName="category"
                  id="category"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  class="{{ fieldHasErrors('category') ? 'is-invalid' : '' }}"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                >
                  <ng-option *ngFor="let cat of categoriesList" [value]="cat.id">{{ cat.parent_id ? "&#8211;" : "" }} {{ cat.name }}</ng-option>
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.category.errors?.required">{{ "ERRORS.SELET_A_CATEGORY" | translate }}</div>
              </div>
              <!--seriale-->
              <div class="form-group col-xl-3 col-md-6 col-12">
                <label for="serial">{{ "INTERNAL_SERIAL" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="serial" class="form-control {{ fieldHasErrors('serial') ? 'is-invalid' : '' }}" formControlName="serial" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.serial.errors?.required">{{ "ERRORS.INSERT_SERIAL" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.serial?.errors?.minlength">{{ "MIN" | translate }} 3 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.serial?.errors?.maxlength">{{ "MAX" | translate }} 100 {{ "CHARACTERS" | translate }}</div>
              </div>
              <!--seriale prodotto-->
              <div class="form-group col-xl-3 col-md-6 col-12">
                <label for="serial">{{ "PRODUCT_SERIAL_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                <input type="text" id="product_serial_number" formControlName="product_serial_number" class="form-control {{ fieldHasErrors('product_serial_number') ? 'is-invalid' : '' }}" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.product_serial_number.errors?.required">{{ "ERRORS.INSERT_SERIAL_PRODUCT" | translate }}</div>
              </div>
              <!--contratto-->
              <div class="form-group col-xl-3 col-md-6 col-12">
                <label for="contract">{{ "CONTRACT" | translate }}</label>
                <input type="text" id="contract" class="form-control {{ fieldHasErrors('contract') ? 'is-invalid' : '' }}" formControlName="contract" />
              </div>
              <!--data fine contratto-->
              <div class="col-12 col-xl-3 col-md-6 form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label for="contract_end_date">{{ "END_DATE_CONTRACT" | translate }}<sup class="text-danger" *ngIf="formGroup.value.contract">*</sup></label>
                  <button class="bg-transparent border-0 text-danger remove-item" type="button" (click)="resetContractEndDate()" *ngIf="formGroup.value.contract_end_date">
                    <i [data-feather]="'trash-2'" size="15"></i>
                  </button>
                </div>
                <app-datepickr id="contract_end_date" (onSelect)="takeDate($event, 'contract_end_date')" [defaultDate]="formGroup.value.contract_end_date"></app-datepickr>
              </div>
              <!--noleggio-->
              <div class="form-group col-xl-5 col-md-6 col-12 d-flex align-items-center" [ngClass.sm]="'mt-025'" [ngClass.xl]="'mt-1 mb-0'">
                <label for="rental" class="mr-05 mb-0">{{ "RENTAL" | translate }}</label>
                <div class="custom-control custom-control-primary custom-switch w-fit ml-1">
                  <input id="rental" type="checkbox" class="custom-control-input" formControlName="rented" />
                  <label class="custom-control-label" for="rental"></label>
                </div>
              </div>
              <div class="col-12 col-xl-3 col-md-6 form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label for="license_end_date">{{ "END_LICENSE" | translate }}<sup class="text-danger" *ngIf="formGroup.value.license_auto_renew">*</sup></label>
                  <button class="bg-transparent border-0 text-danger remove-item" type="button" (click)="resetLicense()" *ngIf="formGroup.value.license_end_date">
                    <i [data-feather]="'trash-2'" size="15"></i>
                  </button>
                </div>
                <app-datepickr id="license_end_date" (onSelect)="takeDate($event, 'license_end_date')" [defaultDate]="formGroup.value.license_end_date"></app-datepickr>
              </div>
              <div class="form-group col-xl-3 col-md-6 col-12 d-flex align-items-center" [ngClass.sm]="'mt-025'" [ngClass.xl]="'mt-1 mb-0'">
                <label for="license_auto_renew" class="mr-05 mb-0">{{ "AUTOMATIC_RENEWAL" | translate }}</label>
                <div class="custom-control custom-control-primary custom-switch w-fit ml-1">
                  <input id="license_auto_renew" type="checkbox" class="custom-control-input" formControlName="license_auto_renew" />
                  <label class="custom-control-label" for="license_auto_renew"></label>
                </div>
              </div>
              <!--caratteristiche-->
              <div class="form-group col-12">
                <label for="description">{{ "CHARACTERISTICS" | translate }}<sup class="text-danger">*</sup></label>
                <angular-editor id="description" [config]="_utilService.defaultEditorConfig" [formControlName]="'description'" class="{{ fieldHasErrors('description') ? 'is-invalid' : '' }}"></angular-editor>
                <div class="invalid-feedback" *ngIf="formGroup.controls.description.errors?.required">{{ "ERRORS.INSERT_DESCRIPTION" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.description?.errors?.minlength">{{ "MIN" | translate }} 3 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.description?.errors?.maxlength">{{ "MAX" | translate }} 65535 {{ "CHARACTERS" | translate }}</div>
              </div>
            </div>
          </div>
          <!--bottoni-->
          <div class="card-footer d-flex justify-content-end" [ngClass.sm]="'text-center'" [ngClass.lg]="'text-right'">
            <button type="button" [routerLink]="'/dashboard/assets/list'" rippleEffect class="btn btn-outline-secondary mr-1">{{ "BACK" | translate }}</button>
            <button type="submit" rippleEffect class="btn btn-primary mr-1">{{ "SAVE" | translate }}</button>
          </div>
        </div>
      </form>
    </section>
  </div>
</div>
